const {
  combine,
  required,
  isBoolean,
  isDate,
  isNumeric,
  isString,
  isLength,
  custom,
  related
} = require('./../../shared/lib/validation/schema');
const { isNil, isEmpty } = require('lodash');

const requiredMessage = 'This field is required';

export const schema = {
  computerTypeId            : combine(required(), isNumeric()),
  computerOperatingSystemId : combine(required(), isNumeric()),
  computerMakeAndModel      : combine(required(), isString(), isLength(1, undefined, requiredMessage)),
  windowsOperatingSystemId  : combine(isNumeric()),
  computerMemorySizeId      : combine(required(), isNumeric()),
  hasSecondMonitor          : combine(required(), isBoolean()),
  hasWebcam                 : combine(required(), isBoolean()),
  antiVirusName             : combine(required(), isString()),
  antiVirusExpired          : combine(required(), isDate()),
  internetProviderId        : combine(required(), isNumeric()),
  internetProviderOther     : isString(),
  internetTypeId            : combine(required(), isNumeric()),
  internetDownloadSpeed     : combine(required(), isNumeric()),
  internetUploadSpeed       : combine(required(), isNumeric()),
  internetAgeId             : combine(required(), isNumeric()),
  hasRouter                 : combine(required(), isBoolean()),
  isRouterLocatedInSameArea : combine(required(), isBoolean()),
  supportsVOIP              : combine(required(), isBoolean()),
  smartPhoneMakeAndModel    : combine(required(), isString()),
  hotspot                   : combine(required(), isBoolean()),
  hasHeadsetWithMicrophone  : combine(required(), isBoolean()),
  hasSpeakersWithMicrophone  : combine(required(), isBoolean())
};



// WEBPACK FOOTER //
// ./shared/models/applicantTechSurvey.js